import React from "react";
import {componentCaller, isBanner, renderBanner} from "./index";

const pageFeeder = data =>  <div className="body-container">
    {isBanner(data[0]) && renderBanner(data[0])}
    <div className="container">
            <div className="mx-md-0">
                {data.map((element, key) =>  !isBanner(element) && componentCaller(Object.keys(element)[0], element[Object.keys(element)[0]]))}
            </div>
    </div>
</div>;

export default pageFeeder;